<template>
    <div>
        <div class="modal hide fade" id="modalStockAdjustmentSerialNumber" tabindex="-1" role="dialog" aria-labelledby="modalStockAdjustmentSerialNumber" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header"><h4 class="modal-title">Search Serial Number</h4></div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label for="payment_date" class="col-sm-3 col-form-label text-left">Serial Number</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" v-model="serial_number"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="button" class="btn btn-primary btn-sm pull-right" data-dismiss="modal" @click="search">Search</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SalesPaymentModal',
  props: ['sales', 'idNew'],
  data () {
    return {
      serial_number: null
    }
  },
  methods: {
    search: function () {
      this.$emit('getSerialNumber', this.serial_number)
    }
  }
}
</script>
